//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class Client {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get Application Health
     * @return Successful Response
     */
    adminHealth(): Observable<any> {
        let url_ = this.baseUrl + "/admin/health";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdminHealth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdminHealth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processAdminHealth(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get messages for account.
     * @param page (optional) 
     * @return Successful Response
     */
    messages(lang: string, page: number | undefined): Observable<GetMessagesResponse> {
        let url_ = this.baseUrl + "/messages/?";
        if (lang === undefined || lang === null)
            throw new Error("The parameter 'lang' must be defined and cannot be null.");
        else
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMessagesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMessagesResponse>;
        }));
    }

    protected processMessages(response: HttpResponseBase): Observable<GetMessagesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMessagesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get count by status of messages, for account.
     * @return Successful Response
     */
    messagesStatus(body: PatchMessageStatusBody): Observable<any> {
        let url_ = this.baseUrl + "/messages/status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMessagesStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMessagesStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processMessagesStatus(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get number of unread messages, for account.
     * @return Successful Response
     */
    messagesCount(): Observable<GetMessagesCountResponse> {
        let url_ = this.baseUrl + "/messages/count";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMessagesCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMessagesCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMessagesCountResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMessagesCountResponse>;
        }));
    }

    protected processMessagesCount(response: HttpResponseBase): Observable<GetMessagesCountResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMessagesCountResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Post Gamtests
     * @return Successful Response
     */
    gamtests(): Observable<PostGamtestResponse> {
        let url_ = this.baseUrl + "/gamtests/";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGamtests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGamtests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PostGamtestResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PostGamtestResponse>;
        }));
    }

    protected processGamtests(response: HttpResponseBase): Observable<PostGamtestResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PostGamtestResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Patch Gamtests
     * @return Successful Response
     */
    gamtestsFinish(): Observable<any> {
        let url_ = this.baseUrl + "/gamtests/finish";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGamtestsFinish(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGamtestsFinish(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processGamtestsFinish(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Put Gamtests
     * @return Successful Response
     */
    gamtestsQuestions(question_id: string, body: PutGamtestParams): Observable<any> {
        let url_ = this.baseUrl + "/gamtests/questions/{question_id}";
        if (question_id === undefined || question_id === null)
            throw new Error("The parameter 'question_id' must be defined.");
        url_ = url_.replace("{question_id}", encodeURIComponent("" + question_id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGamtestsQuestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGamtestsQuestions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processGamtestsQuestions(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Results
     * @return Successful Response
     */
    results(): Observable<GetResultsResponse> {
        let url_ = this.baseUrl + "/results/";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetResultsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetResultsResponse>;
        }));
    }

    protected processResults(response: HttpResponseBase): Observable<GetResultsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetResultsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Results Status
     * @return Successful Response
     */
    resultsStatus(): Observable<GetResultsStatusReponse> {
        let url_ = this.baseUrl + "/results/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResultsStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResultsStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetResultsStatusReponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetResultsStatusReponse>;
        }));
    }

    protected processResultsStatus(response: HttpResponseBase): Observable<GetResultsStatusReponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetResultsStatusReponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Texts
     * @param key (optional) 
     * @param query (optional) 
     * @param lang (optional) 
     * @return Successful Response
     */
    texts(key: string | undefined, query: string | undefined, lang: string | undefined): Observable<GetTextsResponse> {
        let url_ = this.baseUrl + "/texts/?";
        if (key === null)
            throw new Error("The parameter 'key' cannot be null.");
        else if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        if (query === null)
            throw new Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (lang === null)
            throw new Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTexts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTexts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTextsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTextsResponse>;
        }));
    }

    protected processTexts(response: HttpResponseBase): Observable<GetTextsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTextsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Post Events
     * @return Successful Response
     */
    events(body: EventPostParams): Observable<any> {
        let url_ = this.baseUrl + "/events/";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEvents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEvents(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<any>;
                }
            } else
                return _observableThrow(response_) as any as Observable<any>;
        }));
    }

    protected processEvents(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get latest events by type
     * @param types List of types to query
     * @return Successful Response
     */
    eventsLatest(types: any[]): Observable<GetEventsResponse> {
        let url_ = this.baseUrl + "/events/latest?";
        if (types === undefined || types === null)
            throw new Error("The parameter 'types' must be defined and cannot be null.");
        else
            types && types.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "types[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEventsLatest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEventsLatest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEventsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEventsResponse>;
        }));
    }

    protected processEventsLatest(response: HttpResponseBase): Observable<GetEventsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEventsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Post Auth
     * @return Successful Response
     */
    auth(): Observable<AuthResponse> {
        let url_ = this.baseUrl + "/auth/";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthResponse>;
        }));
    }

    protected processAuth(response: HttpResponseBase): Observable<AuthResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = AuthResponse.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Post Auth Renew
     * @return Successful Response
     */
    authRenew(): Observable<AuthResponse> {
        let url_ = this.baseUrl + "/auth/renew";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthRenew(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthRenew(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthResponse>;
        }));
    }

    protected processAuthRenew(response: HttpResponseBase): Observable<AuthResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Interventions
     * @return Successful Response
     */
    interventions(): Observable<GetInterventionsReponse> {
        let url_ = this.baseUrl + "/interventions/";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInterventions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInterventions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetInterventionsReponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetInterventionsReponse>;
        }));
    }

    protected processInterventions(response: HttpResponseBase): Observable<GetInterventionsReponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetInterventionsReponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get number of unread messages, for account.
     * @return Successful Response
     */
    messagesUnreadMessages(): Observable<GetUnreadMessagesCountLoroResult> {
        let url_ = this.baseUrl + "/messages/unread_messages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMessagesUnreadMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMessagesUnreadMessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUnreadMessagesCountLoroResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUnreadMessagesCountLoroResult>;
        }));
    }

    protected processMessagesUnreadMessages(response: HttpResponseBase): Observable<GetUnreadMessagesCountLoroResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUnreadMessagesCountLoroResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 422) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result422: any = null;
            let resultData422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result422 = HTTPValidationError.fromJS(resultData422);
            return throwException("Validation Error", status, _responseText, _headers, result422);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export enum AnalysisEnum {
    Yes = "yes",
    No = "no",
}

export class AnalysisResult implements IAnalysisResult {
    created_at!: Date;
    updated_at!: Date;
    total!: GroupScore;
    dim1!: GroupScore;
    dim2!: GroupScore;
    dimN!: GroupScore;

    [key: string]: any;

    constructor(data?: IAnalysisResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.total = new GroupScore();
            this.dim1 = new GroupScore();
            this.dim2 = new GroupScore();
            this.dimN = new GroupScore();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.created_at = _data["created_at"] ? new Date(_data["created_at"].toString()) : <any>undefined;
            this.updated_at = _data["updated_at"] ? new Date(_data["updated_at"].toString()) : <any>undefined;
            this.total = _data["total"] ? GroupScore.fromJS(_data["total"]) : new GroupScore();
            this.dim1 = _data["dim1"] ? GroupScore.fromJS(_data["dim1"]) : new GroupScore();
            this.dim2 = _data["dim2"] ? GroupScore.fromJS(_data["dim2"]) : new GroupScore();
            this.dimN = _data["dimN"] ? GroupScore.fromJS(_data["dimN"]) : new GroupScore();
        }
    }

    static fromJS(data: any): AnalysisResult {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["created_at"] = this.created_at ? this.created_at.toISOString() : <any>undefined;
        data["updated_at"] = this.updated_at ? this.updated_at.toISOString() : <any>undefined;
        data["total"] = this.total ? this.total.toJSON() : <any>undefined;
        data["dim1"] = this.dim1 ? this.dim1.toJSON() : <any>undefined;
        data["dim2"] = this.dim2 ? this.dim2.toJSON() : <any>undefined;
        data["dimN"] = this.dimN ? this.dimN.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAnalysisResult {
    created_at: Date;
    updated_at: Date;
    total: GroupScore;
    dim1: GroupScore;
    dim2: GroupScore;
    dimN: GroupScore;

    [key: string]: any;
}

export class AuthResponse implements IAuthResponse {
    /** JWT issued by Preventor */
    jwt!: string;

    [key: string]: any;

    constructor(data?: IAuthResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.jwt = _data["jwt"];
        }
    }

    static fromJS(data: any): AuthResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["jwt"] = this.jwt;
        return data;
    }
}

export interface IAuthResponse {
    /** JWT issued by Preventor */
    jwt: string;

    [key: string]: any;
}

export class Event implements IEvent {
    account_id!: string;
    created_at!: Date;
    /** source of event, usually a UUID */
    source_id!: string;
    /** type of event, e.g. 'mark-as-read' */
    type!: string;

    [key: string]: any;

    constructor(data?: IEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.account_id = _data["account_id"];
            this.created_at = _data["created_at"] ? new Date(_data["created_at"].toString()) : <any>undefined;
            this.source_id = _data["source_id"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): Event {
        data = typeof data === 'object' ? data : {};
        let result = new Event();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["account_id"] = this.account_id;
        data["created_at"] = this.created_at ? this.created_at.toISOString() : <any>undefined;
        data["source_id"] = this.source_id;
        data["type"] = this.type;
        return data;
    }
}

export interface IEvent {
    account_id: string;
    created_at: Date;
    /** source of event, usually a UUID */
    source_id: string;
    /** type of event, e.g. 'mark-as-read' */
    type: string;

    [key: string]: any;
}

export class EventPostParams implements IEventPostParams {
    source_id!: string;
    type!: string;

    [key: string]: any;

    constructor(data?: IEventPostParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.source_id = _data["source_id"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): EventPostParams {
        data = typeof data === 'object' ? data : {};
        let result = new EventPostParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["source_id"] = this.source_id;
        data["type"] = this.type;
        return data;
    }
}

export interface IEventPostParams {
    source_id: string;
    type: string;

    [key: string]: any;
}

export enum GamtestEnum {
    Yes = "yes",
    No = "no",
    Pending = "pending",
}

export class GamtestResult implements IGamtestResult {
    created_at!: Date;
    total!: GroupScore;
    time!: GroupScore;
    money!: GroupScore;
    economical!: GroupScore;
    emotional!: GroupScore;
    social!: GroupScore;

    [key: string]: any;

    constructor(data?: IGamtestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.total = new GroupScore();
            this.time = new GroupScore();
            this.money = new GroupScore();
            this.economical = new GroupScore();
            this.emotional = new GroupScore();
            this.social = new GroupScore();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.created_at = _data["created_at"] ? new Date(_data["created_at"].toString()) : <any>undefined;
            this.total = _data["total"] ? GroupScore.fromJS(_data["total"]) : new GroupScore();
            this.time = _data["time"] ? GroupScore.fromJS(_data["time"]) : new GroupScore();
            this.money = _data["money"] ? GroupScore.fromJS(_data["money"]) : new GroupScore();
            this.economical = _data["economical"] ? GroupScore.fromJS(_data["economical"]) : new GroupScore();
            this.emotional = _data["emotional"] ? GroupScore.fromJS(_data["emotional"]) : new GroupScore();
            this.social = _data["social"] ? GroupScore.fromJS(_data["social"]) : new GroupScore();
        }
    }

    static fromJS(data: any): GamtestResult {
        data = typeof data === 'object' ? data : {};
        let result = new GamtestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["created_at"] = this.created_at ? this.created_at.toISOString() : <any>undefined;
        data["total"] = this.total ? this.total.toJSON() : <any>undefined;
        data["time"] = this.time ? this.time.toJSON() : <any>undefined;
        data["money"] = this.money ? this.money.toJSON() : <any>undefined;
        data["economical"] = this.economical ? this.economical.toJSON() : <any>undefined;
        data["emotional"] = this.emotional ? this.emotional.toJSON() : <any>undefined;
        data["social"] = this.social ? this.social.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGamtestResult {
    created_at: Date;
    total: GroupScore;
    time: GroupScore;
    money: GroupScore;
    economical: GroupScore;
    emotional: GroupScore;
    social: GroupScore;

    [key: string]: any;
}

export class GetEventsResponse implements IGetEventsResponse {
    result!: Event[];

    [key: string]: any;

    constructor(data?: IGetEventsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.result = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(Event.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEventsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetEventsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IGetEventsResponse {
    result: Event[];

    [key: string]: any;
}

export class GetInterventionsReponse implements IGetInterventionsReponse {
    account_id!: string;
    date!: Date;
    bets!: number;
    wins!: number;

    [key: string]: any;

    constructor(data?: IGetInterventionsReponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.account_id = _data["account_id"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.bets = _data["bets"];
            this.wins = _data["wins"];
        }
    }

    static fromJS(data: any): GetInterventionsReponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetInterventionsReponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["account_id"] = this.account_id;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["bets"] = this.bets;
        data["wins"] = this.wins;
        return data;
    }
}

export interface IGetInterventionsReponse {
    account_id: string;
    date: Date;
    bets: number;
    wins: number;

    [key: string]: any;
}

export class GetMessagesCountResponse implements IGetMessagesCountResponse {
    result?: any;

    [key: string]: any;

    constructor(data?: IGetMessagesCountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.result = _data["result"];
        }
    }

    static fromJS(data: any): GetMessagesCountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMessagesCountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["result"] = this.result;
        return data;
    }
}

export interface IGetMessagesCountResponse {
    result?: any;

    [key: string]: any;
}

export class GetMessagesResponse implements IGetMessagesResponse {
    /** number of messages for account ID */
    total!: number;
    result!: Message[];
    page!: number;
    next_page?: number | undefined;

    [key: string]: any;

    constructor(data?: IGetMessagesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.result = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.total = _data["total"];
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(Message.fromJS(item));
            }
            this.page = _data["page"];
            this.next_page = _data["next_page"];
        }
    }

    static fromJS(data: any): GetMessagesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMessagesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["total"] = this.total;
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : <any>undefined);
        }
        data["page"] = this.page;
        data["next_page"] = this.next_page;
        return data;
    }
}

export interface IGetMessagesResponse {
    /** number of messages for account ID */
    total: number;
    result: Message[];
    page: number;
    next_page?: number | undefined;

    [key: string]: any;
}

export class GetResultsResponse implements IGetResultsResponse {
    triggered_by?: TriggeredByEnum;
    recommendations?: string[];
    total?: TotalResult;
    analysis?: AnalysisResult;
    gamtest?: GamtestResult;
    previous?: TotalResult;

    [key: string]: any;

    constructor(data?: IGetResultsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.triggered_by = TriggeredByEnum.Empty;
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.triggered_by = _data["triggered_by"] !== undefined ? _data["triggered_by"] : TriggeredByEnum.Empty;
            if (Array.isArray(_data["recommendations"])) {
                this.recommendations = [] as any;
                for (let item of _data["recommendations"])
                    this.recommendations!.push(item);
            }
            this.total = _data["total"] ? TotalResult.fromJS(_data["total"]) : <any>undefined;
            this.analysis = _data["analysis"] ? AnalysisResult.fromJS(_data["analysis"]) : <any>undefined;
            this.gamtest = _data["gamtest"] ? GamtestResult.fromJS(_data["gamtest"]) : <any>undefined;
            this.previous = _data["previous"] ? TotalResult.fromJS(_data["previous"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetResultsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetResultsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["triggered_by"] = this.triggered_by;
        if (Array.isArray(this.recommendations)) {
            data["recommendations"] = [];
            for (let item of this.recommendations)
                data["recommendations"].push(item);
        }
        data["total"] = this.total ? this.total.toJSON() : <any>undefined;
        data["analysis"] = this.analysis ? this.analysis.toJSON() : <any>undefined;
        data["gamtest"] = this.gamtest ? this.gamtest.toJSON() : <any>undefined;
        data["previous"] = this.previous ? this.previous.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetResultsResponse {
    triggered_by?: TriggeredByEnum;
    recommendations?: string[];
    total?: TotalResult;
    analysis?: AnalysisResult;
    gamtest?: GamtestResult;
    previous?: TotalResult;

    [key: string]: any;
}

export class GetResultsStatusReponse implements IGetResultsStatusReponse {
    subscribed!: boolean;
    analysis!: AnalysisEnum;
    gamtest!: GamtestEnum;

    [key: string]: any;

    constructor(data?: IGetResultsStatusReponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.subscribed = _data["subscribed"];
            this.analysis = _data["analysis"];
            this.gamtest = _data["gamtest"];
        }
    }

    static fromJS(data: any): GetResultsStatusReponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetResultsStatusReponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["subscribed"] = this.subscribed;
        data["analysis"] = this.analysis;
        data["gamtest"] = this.gamtest;
        return data;
    }
}

export interface IGetResultsStatusReponse {
    subscribed: boolean;
    analysis: AnalysisEnum;
    gamtest: GamtestEnum;

    [key: string]: any;
}

export class GetTextsResponse implements IGetTextsResponse {
    result!: Text[];

    [key: string]: any;

    constructor(data?: IGetTextsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.result = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["result"])) {
                this.result = [] as any;
                for (let item of _data["result"])
                    this.result!.push(Text.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTextsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTextsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.result)) {
            data["result"] = [];
            for (let item of this.result)
                data["result"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IGetTextsResponse {
    result: Text[];

    [key: string]: any;
}

export class GetUnreadMessagesCountLoroResult implements IGetUnreadMessagesCountLoroResult {
    unread_messages?: number;

    [key: string]: any;

    constructor(data?: IGetUnreadMessagesCountLoroResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.unread_messages = 0;
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.unread_messages = _data["unread_messages"] !== undefined ? _data["unread_messages"] : 0;
        }
    }

    static fromJS(data: any): GetUnreadMessagesCountLoroResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetUnreadMessagesCountLoroResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["unread_messages"] = this.unread_messages;
        return data;
    }
}

export interface IGetUnreadMessagesCountLoroResult {
    unread_messages?: number;

    [key: string]: any;
}

export class GroupScore implements IGroupScore {
    group!: number;
    score!: number;

    [key: string]: any;

    constructor(data?: IGroupScore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.group = _data["group"];
            this.score = _data["score"];
        }
    }

    static fromJS(data: any): GroupScore {
        data = typeof data === 'object' ? data : {};
        let result = new GroupScore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["group"] = this.group;
        data["score"] = this.score;
        return data;
    }
}

export interface IGroupScore {
    group: number;
    score: number;

    [key: string]: any;
}

export class HTTPValidationError implements IHTTPValidationError {
    detail?: ValidationError[];

    [key: string]: any;

    constructor(data?: IHTTPValidationError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["detail"])) {
                this.detail = [] as any;
                for (let item of _data["detail"])
                    this.detail!.push(ValidationError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HTTPValidationError {
        data = typeof data === 'object' ? data : {};
        let result = new HTTPValidationError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.detail)) {
            data["detail"] = [];
            for (let item of this.detail)
                data["detail"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IHTTPValidationError {
    detail?: ValidationError[];

    [key: string]: any;
}

/** Message is an instance of Text. */
export class Message implements IMessage {
    key!: string;
    /** ISO 639 language and territory code */
    lang!: string;
    type!: TextTypeEnum;
    heading!: string;
    text!: string;
    link_text?: string | undefined;
    link_url?: string | undefined;
    link_type?: string | undefined;
    img_url?: string | undefined;
    tags?: Tags;
    status!: StatusEnum;
    created_at!: Date;
    /** UUID of message */
    uuid!: string;

    [key: string]: any;

    constructor(data?: IMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.link_text = "";
            this.link_url = "";
            this.link_type = "";
            this.img_url = "";
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.key = _data["key"];
            this.lang = _data["lang"];
            this.type = _data["type"];
            this.heading = _data["heading"];
            this.text = _data["text"];
            this.link_text = _data["link_text"] !== undefined ? _data["link_text"] : "";
            this.link_url = _data["link_url"] !== undefined ? _data["link_url"] : "";
            this.link_type = _data["link_type"] !== undefined ? _data["link_type"] : "";
            this.img_url = _data["img_url"] !== undefined ? _data["img_url"] : "";
            this.tags = _data["tags"];
            this.status = _data["status"];
            this.created_at = _data["created_at"] ? new Date(_data["created_at"].toString()) : <any>undefined;
            this.uuid = _data["uuid"];
        }
    }

    static fromJS(data: any): Message {
        data = typeof data === 'object' ? data : {};
        let result = new Message();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["key"] = this.key;
        data["lang"] = this.lang;
        data["type"] = this.type;
        data["heading"] = this.heading;
        data["text"] = this.text;
        data["link_text"] = this.link_text;
        data["link_url"] = this.link_url;
        data["link_type"] = this.link_type;
        data["img_url"] = this.img_url;
        data["tags"] = this.tags;
        data["status"] = this.status;
        data["created_at"] = this.created_at ? this.created_at.toISOString() : <any>undefined;
        data["uuid"] = this.uuid;
        return data;
    }
}

/** Message is an instance of Text. */
export interface IMessage {
    key: string;
    /** ISO 639 language and territory code */
    lang: string;
    type: TextTypeEnum;
    heading: string;
    text: string;
    link_text?: string | undefined;
    link_url?: string | undefined;
    link_type?: string | undefined;
    img_url?: string | undefined;
    tags?: Tags;
    status: StatusEnum;
    created_at: Date;
    /** UUID of message */
    uuid: string;

    [key: string]: any;
}

export enum MessageStatusEnum {
    Read = "read",
    Unread = "unread",
}

export class PatchMessageStatusBody implements IPatchMessageStatusBody {
    status!: MessageStatusEnum;
    uuid!: string;

    [key: string]: any;

    constructor(data?: IPatchMessageStatusBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.status = _data["status"];
            this.uuid = _data["uuid"];
        }
    }

    static fromJS(data: any): PatchMessageStatusBody {
        data = typeof data === 'object' ? data : {};
        let result = new PatchMessageStatusBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["status"] = this.status;
        data["uuid"] = this.uuid;
        return data;
    }
}

export interface IPatchMessageStatusBody {
    status: MessageStatusEnum;
    uuid: string;

    [key: string]: any;
}

export class PostGamtestResponse implements IPostGamtestResponse {
    version!: string;
    question_labels!: string[];
    question_extra_labels!: string[];

    [key: string]: any;

    constructor(data?: IPostGamtestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.question_labels = [];
            this.question_extra_labels = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.version = _data["version"];
            if (Array.isArray(_data["question_labels"])) {
                this.question_labels = [] as any;
                for (let item of _data["question_labels"])
                    this.question_labels!.push(item);
            }
            if (Array.isArray(_data["question_extra_labels"])) {
                this.question_extra_labels = [] as any;
                for (let item of _data["question_extra_labels"])
                    this.question_extra_labels!.push(item);
            }
        }
    }

    static fromJS(data: any): PostGamtestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PostGamtestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["version"] = this.version;
        if (Array.isArray(this.question_labels)) {
            data["question_labels"] = [];
            for (let item of this.question_labels)
                data["question_labels"].push(item);
        }
        if (Array.isArray(this.question_extra_labels)) {
            data["question_extra_labels"] = [];
            for (let item of this.question_extra_labels)
                data["question_extra_labels"].push(item);
        }
        return data;
    }
}

export interface IPostGamtestResponse {
    version: string;
    question_labels: string[];
    question_extra_labels: string[];

    [key: string]: any;
}

export class PutGamtestParams implements IPutGamtestParams {
    answer!: number;

    [key: string]: any;

    constructor(data?: IPutGamtestParams) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.answer = _data["answer"];
        }
    }

    static fromJS(data: any): PutGamtestParams {
        data = typeof data === 'object' ? data : {};
        let result = new PutGamtestParams();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["answer"] = this.answer;
        return data;
    }
}

export interface IPutGamtestParams {
    answer: number;

    [key: string]: any;
}

export enum StatusEnum {
    Read = "read",
    Unread = "unread",
}

export class Text implements IText {
    key!: string;
    /** ISO 639 language and territory code */
    lang!: string;
    type!: TextTypeEnum;
    heading!: string;
    text!: string;
    link_text?: string | undefined;
    link_url?: string | undefined;
    link_type?: string | undefined;
    img_url?: string | undefined;
    tags?: tags;

    [key: string]: any;

    constructor(data?: IText) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.link_text = "";
            this.link_url = "";
            this.link_type = "";
            this.img_url = "";
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.key = _data["key"];
            this.lang = _data["lang"];
            this.type = _data["type"];
            this.heading = _data["heading"];
            this.text = _data["text"];
            this.link_text = _data["link_text"] !== undefined ? _data["link_text"] : "";
            this.link_url = _data["link_url"] !== undefined ? _data["link_url"] : "";
            this.link_type = _data["link_type"] !== undefined ? _data["link_type"] : "";
            this.img_url = _data["img_url"] !== undefined ? _data["img_url"] : "";
            this.tags = _data["tags"];
        }
    }

    static fromJS(data: any): Text {
        data = typeof data === 'object' ? data : {};
        let result = new Text();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["key"] = this.key;
        data["lang"] = this.lang;
        data["type"] = this.type;
        data["heading"] = this.heading;
        data["text"] = this.text;
        data["link_text"] = this.link_text;
        data["link_url"] = this.link_url;
        data["link_type"] = this.link_type;
        data["img_url"] = this.img_url;
        data["tags"] = this.tags;
        return data;
    }
}

export interface IText {
    key: string;
    /** ISO 639 language and territory code */
    lang: string;
    type: TextTypeEnum;
    heading: string;
    text: string;
    link_text?: string | undefined;
    link_url?: string | undefined;
    link_type?: string | undefined;
    img_url?: string | undefined;
    tags?: tags;

    [key: string]: any;
}

export enum TextTypeEnum {
    Recommendation = "recommendation",
    Notification = "notification",
}

export class TotalResult implements ITotalResult {
    created_at!: Date;
    group!: number;
    risk!: number;
    risk_id!: number;
    updated_at!: Date;

    [key: string]: any;

    constructor(data?: ITotalResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.created_at = _data["created_at"] ? new Date(_data["created_at"].toString()) : <any>undefined;
            this.group = _data["group"];
            this.risk = _data["risk"];
            this.risk_id = _data["risk_id"];
            this.updated_at = _data["updated_at"] ? new Date(_data["updated_at"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TotalResult {
        data = typeof data === 'object' ? data : {};
        let result = new TotalResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["created_at"] = this.created_at ? this.created_at.toISOString() : <any>undefined;
        data["group"] = this.group;
        data["risk"] = this.risk;
        data["risk_id"] = this.risk_id;
        data["updated_at"] = this.updated_at ? this.updated_at.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITotalResult {
    created_at: Date;
    group: number;
    risk: number;
    risk_id: number;
    updated_at: Date;

    [key: string]: any;
}

export enum TriggeredByEnum {
    Analysis = "analysis",
    Gamtest = "gamtest",
    Empty = "",
}

export class ValidationError implements IValidationError {
    loc!: Loc[];
    msg!: string;
    type!: string;

    [key: string]: any;

    constructor(data?: IValidationError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.loc = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["loc"])) {
                this.loc = [] as any;
                for (let item of _data["loc"])
                    this.loc!.push(item);
            }
            this.msg = _data["msg"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ValidationError {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.loc)) {
            data["loc"] = [];
            for (let item of this.loc)
                data["loc"].push(item);
        }
        data["msg"] = this.msg;
        data["type"] = this.type;
        return data;
    }
}

export interface IValidationError {
    loc: Loc[];
    msg: string;
    type: string;

    [key: string]: any;
}

export class Tags implements ITags {

    [key: string]: any;

    constructor(data?: ITags) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): Tags {
        data = typeof data === 'object' ? data : {};
        let result = new Tags();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface ITags {

    [key: string]: any;
}

export class tags implements Itags {

    [key: string]: any;

    constructor(data?: Itags) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): tags {
        data = typeof data === 'object' ? data : {};
        let result = new tags();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface Itags {

    [key: string]: any;
}

export class Loc implements ILoc {

    [key: string]: any;

    constructor(data?: ILoc) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): Loc {
        data = typeof data === 'object' ? data : {};
        let result = new Loc();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface ILoc {

    [key: string]: any;
}

export class ApiException extends Error {
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
